<script setup lang="ts">
import video from '@/assets/main/video.mp4'
import second from '@/assets/show/image-1.webp'
import third from '@/assets/show/image-2.webp'
import four from '@/assets/show/image-3.webp'
import first from '@/assets/show/image.webp'

defineProps<{
    showGallery?: boolean
}>()
</script>

<template>
    <!-- Video Section -->
    <div class="relative h-64 w-full rounded-2xl sm:max-w-64 lg:h-[380px] lg:max-w-[380px]">
        <video class="absolute inset-0 h-full w-full rounded-2xl bg-black" controlsList="nofullscreen" autoplay muted loop playsinline preload="none">
            <source :src="video" type="video/mp4" />
        </video>
    </div>

    <!-- Image Gallery -->
    <div v-if="showGallery" class="grid grid-cols-4 gap-2 sm:gap-4">
        <img :src="first" alt="Event image 1" class="aspect-square h-full w-full rounded-2xl object-cover" />
        <img :src="second" alt="Event image 2" class="aspect-square h-full w-full rounded-2xl object-cover" />
        <img :src="third" alt="Event image 3" class="aspect-square h-full w-full rounded-2xl object-cover" />
        <img :src="four" alt="Event image 4" class="aspect-square h-full w-full rounded-2xl object-cover" />
    </div>
</template>
